import script from "./H1Form.vue?vue&type=script&lang=ts&setup=true"
export * from "./H1Form.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__